const { getStageByDomain } = require('./helpers');

// STAGE
export const STAGE = getStageByDomain();
console.log('STAGE: ==============> ', STAGE);

// BASE URLS - Front-End
const baseURLs = {
  local: 'http://localhost:3000',
  stage: 'https://uag-portal-stage.activmedia.io',
  prod: 'https://understandingag.activmedia.io'
}

// API
export const PROD_API_LAMBDA = 'https://ll02atk2r9.execute-api.us-east-1.amazonaws.com/uag-prod/api/v1/';
export const STAGE_API_LAMBDA = 'https://umu8ltniff.execute-api.us-east-1.amazonaws.com/stage/api/v1/'; //'https://4xmj7t3a7b.execute-api.us-east-1.amazonaws.com/stage/api/v1/'
export const WL_SHA_LAMBDA   = 'https://94586ufob4.execute-api.us-east-1.amazonaws.com/wl-sha-stage/api/v1/';
export const WL_UAG_LAMBDA   = 'https://pra4k9b166.execute-api.us-east-1.amazonaws.com/uag-stage/api/v1/';
export const LOCAL_LAMBDA    = 'http://localhost:8050/api/v1/'

let API = '';
switch (STAGE) {
  case 'local':
    API = LOCAL_LAMBDA;
    break;
  case 'stage':
    API = WL_UAG_LAMBDA;
    break;
  case 'prod':
    API = PROD_API_LAMBDA;
    break;
  default:
    API = WL_UAG_LAMBDA;
}

export const API_LOCAL = API;

// Lambda Server URL
export const USE_LOCAL = ('local' === STAGE); // false;  // which enviroment to use the lambda api services 

// Timeouts
export const INITIAL_WARNING_DURATION = 1000 * 60 * 60; // 60 minutes
export const EXTRA_LOGOUT_DURATION = 1000 * 60 * 70; // on 70 minutes, force logout

// Player URL
const PLAYER_ENVIRONMENT = STAGE;
const playerURLs = {
  // 'local' : 'http://localhost.narrasys.com:8080',     // local player

  // 'stage' : 'https://stage-player-sha.narrasys.com', // Stage: using wl sha
  // 'local' : 'https://stage-player-sha.narrasys.com',    // local: USING SHA
  //  'stage' : 'https://stage-player-sha.narrasys.com',   // stage: USING SHA

  // 'local' : 'https://uag-player-stage.activmedia.io',   // local: USING activmedia domain
  //   'stage' : 'https://uag-player-stage.activmedia.io',   // stage: USING activmedia domain
  //   'prod'  : 'https://player-regenagonline.narrasys.com' , // prod: USING activmedia domain

  'local': 'https://am-player.narrasys.com', // local: USING AM PROD
  'stage': 'https://am-player.narrasys.com', // stage: USING AM Prod (as if in prod)
  'prod': 'https://am-player.narrasys.com', // prod: USING AM Prod

  // 'local' : 'https://player-soilhealthacademy.narrasys.com', // local: USING SHA PROD
  //'prod'  : 'https://player-soilhealthacademy.narrasys.com/' // prod: USING SHA PROD
}
// export const PLAYER_BASE_URL = PLAYER_IS_LOCAL ? 'http://localhost.narrasys.com:8080' : 'https://player-soilhealthacademy.narrasys.com'; 
export const PLAYER_BASE_URL = playerURLs[PLAYER_ENVIRONMENT];

// Stripe
const stripeConfig = {
  local: {
    publicKey: 'pk_test_dIeEXvyHLaBwFRSa2fL3w6Pw00g1FI0RZ1',
    basicProductPlan: 'price_1JpciuADndcRBW2uj9AJ8kpy',
  },
  stage: {
    publicKey: 'pk_test_dIeEXvyHLaBwFRSa2fL3w6Pw00g1FI0RZ1',
    basicProductPlan: 'price_1JpciuADndcRBW2uj9AJ8kpy',
  },
  prod: {
    publicKey: 'pk_live_GYx5VqEUYqIcwGYhUZExSsMZ00nUZ1r0Jm',
    basicProductPlan: 'price_1Jpce8ADndcRBW2uZkcUUDMH', 
  },
};

export const STRIPE_PUBLIC_KEY = stripeConfig[STAGE].publicKey;
export const STRIPE_BASIC_PRODUCT_ID = stripeConfig[STAGE].basicProductPlan;
export const STRIPE_BASE_URL = baseURLs[STAGE]; 

// Google Tag Manager
export const GTM_ID = 'GTM-TX93D28';

// use auto-confirm rather than verification code:
export const REGISTRATION_AUTO_CONFIRM = true;

// recaptcha
export const RECAPTCHA_KEY = '6LcrJW8aAAAAAHf_pGgcrTn4mt1YzA2_D9dka8g1';

// version
export const PRODUCT_SHORT_NAME = 'UAG';
export const ORGANIZATION_ALIAS = 'regenagonline';
export const COURSE_ALIAS = 'regenag-101';
export const HORIZONTAL_LOGO = 'https://activmedia-uploads.s3.amazonaws.com/logos/uag/UA+Horizontal_Full+Color.png'
export const LOGO_ONLY = 'https://activmedia-uploads.s3.amazonaws.com/logos/uag/UA+Horizontal_Full+Color+LAYERS.png'
export const VERSION = 'v-uag-0.001v-prod' // 1/3/22 - Branched from 1st production release
                                           // 1/5/22 - fix test for completion certificate
                                           // 1/28/22 - bug fix for completion v2
                                           // 1/31/22 - remove -demo from demo class names
                                           // 2/16 - add sub state to csv download (inactive/cancel) - 3rd version
                                           // 4/04 - reduce demo to 2 modules, add in impersonate from Administration
                                           // 04/12 - bulk invite update existing users
                                           // 10/21/22 - edd: usage report
                                           // 12/22/22 - ck: renewal and expiration bugfixes
                                           // 8/2/23 - download large csv
